'use strict';

var _REF_THUMB, _REF_PRIMARY, _RESIZE_WIDTHS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SV = require('server-vars');
var endpoints = require('dibs-endpoints');

var _require = require('./util'),
    addTokenToUrl = _require.addTokenToUrl,
    fetchWrapper = _require.fetchWrapper,
    addHeaders = _require.addHeaders,
    conditionalPromiseHelpers = _require.conditionalPromiseHelpers,
    makeRequest = _require.makeRequest;

// statuses


var STATUS_ACTIVE = 'ACTIVE';
var STATUS_PENDING = 'PENDING';
var STATUS_DELETED = 'DELETED';

// References used for resizing photos
var REF_THUMB = 'thumb';
var REF_PRIMARY = 'primary';

// Orientations (determine resizeWidth)
var PORTRAIT = 'PORTRAIT';
var LANDSCAPE = 'LANDSCAPE';

// Resized widths
var RESIZE_WIDTHS = (_RESIZE_WIDTHS = {}, _defineProperty(_RESIZE_WIDTHS, REF_THUMB, (_REF_THUMB = {}, _defineProperty(_REF_THUMB, PORTRAIT, 400), _defineProperty(_REF_THUMB, LANDSCAPE, 400), _REF_THUMB)), _defineProperty(_RESIZE_WIDTHS, REF_PRIMARY, (_REF_PRIMARY = {}, _defineProperty(_REF_PRIMARY, PORTRAIT, 800), _defineProperty(_REF_PRIMARY, LANDSCAPE, 1200), _REF_PRIMARY)), _RESIZE_WIDTHS);

/**
 * Sends a PUT request to the media service to update the photo with data
 * @param {} id
 * @param {} data
 * @returns {}
 */
function updatePhoto(id, data) {
    var url = addTokenToUrl(endpoints.uploadPhoto(id));

    return fetchWrapper(url, addHeaders({
        method: 'put',
        body: JSON.stringify(data)
    }));
}

/**
 * Sends a POST request to the media service to upload a photo in PENDING state
 * @param {String} imageType
 * @param {Object} data
 * @returns {Promise}
 */
function uploadPhoto(imageType, data) {
    var url = addTokenToUrl(endpoints.uploadPhoto(imageType));

    return fetchWrapper(url, {
        method: 'post',
        body: data
    });
}

/**
 * Sends a POST request to the media service to upload a photo in PENDING state
 * @param {String} imageType
 * @param {Object} data
 * @returns {Promise}
 */
function uploadPhotoByUrl(imageType, data) {
    var url = addTokenToUrl(endpoints.uploadPhotoByUrl(imageType));

    return fetchWrapper(url, addHeaders({
        method: 'post',
        body: JSON.stringify(data)
    }));
}

/**
 * Sends a POST request to the media service to upload a video in PENDING state
 * @param {Object} data
 * @returns {Promise}
 */
function uploadVideo(data) {
    var url = addTokenToUrl(endpoints.uploadVideo());

    return fetchWrapper(url, addHeaders({
        method: 'post',
        body: JSON.stringify(data)
    }));
}

/**
 * Sends a PUT request to the media service to update the video with data
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
function updateVideo(id, data) {
    var url = addTokenToUrl(endpoints.getVideo(id));

    return fetchWrapper(url, addHeaders({
        method: 'put',
        body: JSON.stringify(data)
    }));
}

/**
 * Sends a DELETE request to the media service to delete the video
 * @param {Number} id
 * @returns {Promise}
 */
function deleteVideo(id) {
    var url = addTokenToUrl(endpoints.getVideo(id));

    return fetchWrapper(url, addHeaders({
        method: 'delete'
    }));
}

/**
 * Sends a POST request to the media service to cut sizes of a photo
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
function resizePhoto(id, data) {
    var url = addTokenToUrl(endpoints.resizePhoto(id));

    return fetchWrapper(url, addHeaders({
        method: 'post',
        body: JSON.stringify(data)
    }));
}

/**
 * Helper function for ensureValidPhotoDimensions that can get overridden in the payload by unit tests etc
 * @return {Object} An object with a create() and dispose() method
 */
function createImageFromFile() {
    return {
        create: function create(file) {
            return new Promise(function (resolve) {
                var img = new Image();
                img.onload = function () {
                    resolve(img);
                };
                img.src = window.URL.createObjectURL(file);
            });
        },
        dispose: function dispose(img) {
            window.URL.revokeObjectURL(img.src);
        }
    };
}

// Constants Photo Statuses
exports.STATUSES = {
    active: STATUS_ACTIVE,
    pending: STATUS_PENDING,
    deleted: STATUS_DELETED
};

// Constants reference types (for resize)
exports.REF_TYPES = {
    thumb: REF_THUMB,
    primary: REF_PRIMARY
};

// Path segments (where backend saves the photo)
exports.PATH_SEGMENTS = {
    trade: '/trade'
};

// Constants representing the various photo types that the media service recognizes
exports.PHOTO_TYPES = {
    // 1. storefront photo types:
    storefrontLogo: 'DEALER_STOREFRONT_LOGO',
    storefrontBanner: 'DEALER_STOREFRONT_BANNER',
    storefrontCarousel: 'DEALER_STOREFRONT_CAROUSEL',
    storefrontHeadshot: 'DEALER_STOREFRONT_HEADSHOT',
    // 2. legacy dealer logos types:
    legacyPdpLogo: 'DEALER_PDP_LOGO',
    legacySearchBrowseLogo: 'DEALER_SEARCH_BROWSE_LOGO',
    legacyStorefrontBanner: 'LEGACY_DEALER_STOREFRONT_BANNER',
    legacyMailLogo: 'DEALER_MAIL_LOGO',
    // 3. trade photo types:
    tradeArticle: 'TRADE_ARTICLE',
    tradeProfile: 'TRADE_PROFILE',
    tradeSplash: 'TRADE_SPLASH',
    tradeSourcing: 'TRADE_SOURCING'
};

/**
 * Returns a default set of arguments to pass to the upload method
 * @param   {Object} payload
 * @param   {File}   file
 * @param   {String} dealerId
 * @param   {String} photoType
 * @returns {Object}
 */
exports.defaultPhotoArgs = function (payload, file, dealerId, photoType) {
    return Object.assign({}, { file: file, dealerId: dealerId, data: { status: STATUS_PENDING }, pathSegment: dealerId, photoType: photoType }, payload);
};

/**
 * Returns a photo object
 * @param {object} [photo]
 * @param {string} [status]
 * @returns {object}
 */
function defaultPhoto(_ref) {
    var photo = _ref.photo,
        status = _ref.status;

    return Object.assign({
        apiType: 'photo',
        status: status || STATUS_PENDING
    }, photo);
}
exports.defaultPhoto = defaultPhoto;

/**
 * Returns a photoResizeRequest object
 * @param {string}        reference
 * @param {number|string} newWidth
 * @param {string}        [type]
 * @returns {object}
 */
function defaultPhotoResizeRequest(_ref2) {
    var reference = _ref2.reference,
        newWidth = _ref2.newWidth,
        type = _ref2.type;

    return {
        apiType: 'photoResizeRequest',
        type: type || 'RESIZE',
        reference: reference,
        newWidth: newWidth
    };
}
exports.defaultPhotoResizeRequest = defaultPhotoResizeRequest;

/**
 * Uploads a new photo to the media service
 *  - if passed payload.file    => will uploadPhoto
 *  - if passed payload.url     => will uploadPhotoByUrl
 *
 * @param  {Object}   payload
 * @param  {File}     [payload.file] - The file that will be uploaded
 * @param  {String}   [payload.url]- The url that will be uploaded
 * @param  {Object}   payload.errorMessages - Optional, used to override default error messages
 * @param  {String}   payload.photoType
 * @param  {String}   payload.pathSegment - The media service will use this value as part of the file path.
 * @param  {Object}   payload.data - The 'mediaJson' that should be sent to the service
 * @param  {Function} payload.formDataFactory - A function that creates a FormData object. Mainly overridable for unit testing.
 * @param  {Function} onStart - function(args) {} - Called when the upload begins
 * @param  {Function} onSuccess - function(data) {} - Called when the upload has completed successfully
 * @param  {Function} onFail - function(err) {} - Called if the upload fails
 * @return {Promise}
 */
exports.uploadPhoto = function (_ref3) {
    var payload = _ref3.payload,
        _ref3$onStart = _ref3.onStart,
        onStart = _ref3$onStart === undefined ? function () {} : _ref3$onStart,
        _ref3$onSuccess = _ref3.onSuccess,
        onSuccess = _ref3$onSuccess === undefined ? function () {} : _ref3$onSuccess,
        _ref3$onFail = _ref3.onFail,
        onFail = _ref3$onFail === undefined ? function () {} : _ref3$onFail;
    var file = payload.file,
        url = payload.url,
        _payload$errorMessage = payload.errorMessages,
        errorMessages = _payload$errorMessage === undefined ? {} : _payload$errorMessage,
        photoType = payload.photoType,
        pathSegment = payload.pathSegment,
        _payload$data = payload.data,
        data = _payload$data === undefined ? {} : _payload$data,
        _payload$formDataFact = payload.formDataFactory,
        formDataFactory = _payload$formDataFact === undefined ? function () {
        return new FormData();
    } : _payload$formDataFact;

    // default to photoUpload

    var shouldUploadByUrl = !!url && !(file && file.name);

    // default to pending
    data.status = data.status || 'PENDING';

    // Get servicePayload and possibleError for 2 types of requests
    var servicePayload = { pathSegment: pathSegment };
    var possibleError = [];
    if (shouldUploadByUrl) {
        // body sent along in url POST request
        servicePayload.url = url;
        servicePayload.photoData = data;
        // Possible Error if uploading a photo url
        possibleError[0] = !url;
        possibleError[1] = { message: errorMessages.urlNotSpecified || 'Url was not specified.' };
    } else {
        // Form data to send along with the file in the POST request
        servicePayload.mediaJson = JSON.stringify(data);
        // Possible Error if uploading a photo file
        possibleError[0] = !(file && file.name);
        possibleError[1] = { message: errorMessages.fileNotSpecified || 'File was not specified.' };
    }

    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe.ok,
            fail = _conditionalPromiseHe.fail,
            failIfAny = _conditionalPromiseHe.failIfAny;

        var possibleErrors = [possibleError, [!pathSegment, { message: 'Path segment was not specified.' }], [!photoType, { message: 'Photo type was not specified.' }]];

        if (failIfAny(possibleErrors)) {
            return;
        }

        // Done Checking Errors
        var upload = void 0;
        if (shouldUploadByUrl) {
            upload = function upload() {
                onStart({ payload: servicePayload });
                return uploadPhotoByUrl(photoType, servicePayload);
            };
        } else {
            var formData = Object.keys(servicePayload).reduce(function (prev, curr) {
                prev.append(curr, servicePayload[curr]);
                return prev;
            }, formDataFactory());

            // Append the file (multipart/formdata)
            formData.append('files', file);

            upload = function upload() {
                onStart({ filename: file.name });
                return uploadPhoto(photoType, formData);
            };
        }

        upload().then(function (response) {
            ok({ photo: response.result });
        }).catch(function (err) {
            fail(err);
        });
    });
};

var possibleVideoErrors = function possibleVideoErrors() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var errorMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var additionalErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return [[!payload.url, { message: errorMessages.urlNotSpecified || 'Url was not specified.' }], [!payload.type, { message: errorMessages.typeNotSpecified || 'Video type was not specified.' }], [!payload.apiType, { message: errorMessages.apiTypeNotSpecified || 'Api type was not specified.' }]].concat([additionalErrors]);
};

/**
 * Uploads a new video to the media service
 * @param  {Object}   payload
 * @param  {Object}   payload.errorMessages - Optional, used to override default error messages
 * @param  {Object}   payload.data - The payload that should be sent to the service
 * @param  {Function} onStart - function(args) {} - Called when the upload begins
 * @param  {Function} onSuccess - function(data) {} - Called when the upload has completed successfully
 * @param  {Function} onFail - function(err) {} - Called if the upload fails
 * @return {Promise}
 */
exports.uploadVideo = function (_ref4) {
    var payload = _ref4.payload,
        _ref4$onStart = _ref4.onStart,
        _onStart = _ref4$onStart === undefined ? function () {} : _ref4$onStart,
        _ref4$onSuccess = _ref4.onSuccess,
        onSuccess = _ref4$onSuccess === undefined ? function () {} : _ref4$onSuccess,
        _ref4$onFail = _ref4.onFail,
        onFail = _ref4$onFail === undefined ? function () {} : _ref4$onFail;

    var _payload$errorMessage2 = payload.errorMessages,
        errorMessages = _payload$errorMessage2 === undefined ? {} : _payload$errorMessage2,
        _payload$data2 = payload.data,
        servicePayload = _payload$data2 === undefined ? {} : _payload$data2;
    // default to pending

    servicePayload.status = servicePayload.status || 'PENDING';

    return makeRequest({
        request: function request() {
            return uploadVideo(servicePayload);
        },
        possibleErrors: possibleVideoErrors(servicePayload, errorMessages),
        onStart: function onStart() {
            return _onStart({ payload: servicePayload });
        },
        onSuccess: onSuccess,
        onFail: onFail,
        transformResponse: function transformResponse(response) {
            return { video: response.result };
        }
    });
};

/**
 * Sends an update request to the media service for a previously-uploaded video
 * @param  {Object}   payload
 * @param  {Object}   payload.errorMessages - Optional, used to override default error messages
 * @param  {Object}   payload.data - The payload that should be sent to the service
 * @param  {Function} onSuccess - function(data) {} - Called when the upload has completed successfully
 * @param  {Function} onFail - function(err) {} - Called if the upload fails
 * @returns {Promise}
 */
exports.updateVideo = function (_ref5) {
    var payload = _ref5.payload,
        _ref5$onSuccess = _ref5.onSuccess,
        onSuccess = _ref5$onSuccess === undefined ? function () {} : _ref5$onSuccess,
        _ref5$onFail = _ref5.onFail,
        onFail = _ref5$onFail === undefined ? function () {} : _ref5$onFail;
    var _payload$errorMessage3 = payload.errorMessages,
        errorMessages = _payload$errorMessage3 === undefined ? {} : _payload$errorMessage3,
        _payload$data3 = payload.data,
        servicePayload = _payload$data3 === undefined ? {} : _payload$data3;
    var id = servicePayload.id;


    return makeRequest({
        request: function request() {
            return updateVideo(id, servicePayload);
        },
        possibleErrors: possibleVideoErrors(servicePayload, errorMessages, [!id, { message: errorMessages.idNotSpecified || 'ID was not specified.' }]),
        onSuccess: onSuccess,
        onFail: onFail,
        transformResponse: function transformResponse(response) {
            return { id: id, response: response };
        }
    });
};

/**
 * Sends an delete request to the media service for a previously-uploaded video
 * @param  {Object}   payload
 * @param  {Object}   payload.errorMessages - Optional, used to override default error messages
 * @param  {Object}   payload.id - id of video to delete
 * @param  {Function} onSuccess - function() {} - Called when the upload has completed successfully
 * @param  {Function} onFail - function(err) {} - Called if the upload fails
 * @returns {Promise}
 */
exports.deleteVideo = function (_ref6) {
    var payload = _ref6.payload,
        _ref6$onSuccess = _ref6.onSuccess,
        onSuccess = _ref6$onSuccess === undefined ? function () {} : _ref6$onSuccess,
        _ref6$onFail = _ref6.onFail,
        onFail = _ref6$onFail === undefined ? function () {} : _ref6$onFail;
    var _payload$errorMessage4 = payload.errorMessages,
        errorMessages = _payload$errorMessage4 === undefined ? {} : _payload$errorMessage4,
        id = payload.id;


    return makeRequest({
        request: function request() {
            return deleteVideo(id);
        },
        possibleErrors: [[!id, { message: errorMessages.idNotSpecified || 'ID was not specified.' }]],
        onSuccess: onSuccess,
        onFail: onFail,
        transformResponse: function transformResponse(response) {
            return { id: id, response: response };
        }
    });
};

/**
 * Sends an update request to the media service for a previously-uploaded photo
 * @param   {Object}   payload
 * @param   {Function} onSuccess
 * @param   {Function} onFail
 * @returns {Promise}
 */
exports.updatePhoto = function (_ref7) {
    var payload = _ref7.payload,
        onSuccess = _ref7.onSuccess,
        onFail = _ref7.onFail;
    var id = payload.id,
        data = payload.data;


    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe2 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe2.ok,
            fail = _conditionalPromiseHe2.fail,
            failIfAny = _conditionalPromiseHe2.failIfAny;

        var possibleErrors = [[!id, { message: 'Photo id must be specified when updating.' }], [!data, { message: 'Data was not provided.' }]];

        if (failIfAny(possibleErrors)) {
            return;
        }

        // give the model an id so it'll do a PUT
        updatePhoto(id, data).then(function (response) {
            ok({ id: id, response: response });
        }).catch(function (response) {
            fail({ id: id, response: response });
        });
    });
};

/**
 * Sends a request to the media service to force a download of the selected photo
 * @param   {Object}  payload
 * @param   {String}  payload.id - the photoId to be downloaded
 * @returns {Promise}
 */
exports.downloadPhoto = function (payload) {
    var id = payload.id;


    return new Promise(function (resolve) {
        var link = document.createElement('a');
        var url = endpoints.uploadPhoto(id) + '/download';
        link.setAttribute('href', url);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        resolve();
    });
};

/**
 * Sends a request to the media service to cut sizes (specified in references) of the selected photo
 * @param   {Object}  payload
 * @param   {Object}  [payload.photo]         - the photo to be resized
 * @param   {Array}   [payload.references]
 *
 * @param   {String}  [payload.id]            - the photoId of the photo to be resized
 * @param   {Array}   [payload.dataList]
 * @param   {String}  [payload.orientation]   - either 'PORTRAIT' or 'LANDSCAPE'
 *
 * @param   {Function} [onStart]    - function(args) {} Called when resize begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when resize has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if resize fails
 * @returns {Promise}
 */
exports.resizePhoto = function (_ref8) {
    var payload = _ref8.payload,
        _ref8$onStart = _ref8.onStart,
        onStart = _ref8$onStart === undefined ? function () {} : _ref8$onStart,
        _ref8$onSuccess = _ref8.onSuccess,
        onSuccess = _ref8$onSuccess === undefined ? function () {} : _ref8$onSuccess,
        _ref8$onFail = _ref8.onFail,
        onFail = _ref8$onFail === undefined ? function () {} : _ref8$onFail;

    var _ref9 = payload || {},
        _ref9$photo = _ref9.photo,
        photo = _ref9$photo === undefined ? {} : _ref9$photo,
        _ref9$references = _ref9.references,
        references = _ref9$references === undefined ? [] : _ref9$references;

    var id = payload.id,
        dataList = payload.dataList,
        orientation = payload.orientation;

    var possibleErrors = void 0;
    var invalidReference = void 0;

    // Get the photo id
    id = id || photo.id;

    // Get the orientation from the photo if not passed in payload
    if (!orientation || [PORTRAIT, LANDSCAPE].indexOf(orientation) < 0) {
        var _ref10 = photo.dimension || {},
            width = _ref10.width,
            height = _ref10.height;

        orientation = width > height ? LANDSCAPE : PORTRAIT;
    }

    // Build the dataList
    dataList = dataList || references.map(function (reference) {
        // break out of loop if there is an invalid reference
        if (invalidReference || !RESIZE_WIDTHS[reference] || !RESIZE_WIDTHS[reference][orientation]) {
            invalidReference = invalidReference || reference;
            return;
        }

        // return a photoResizeRequest object {apiType: 'photoResizeRequest'...}
        return defaultPhotoResizeRequest({
            reference: reference,
            newWidth: RESIZE_WIDTHS[reference][orientation]
        });
    });

    // Return a promise and throw error or make request
    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe3 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe3.ok,
            fail = _conditionalPromiseHe3.fail,
            failIfAny = _conditionalPromiseHe3.failIfAny;

        // Get Possible Errors


        possibleErrors = [[!id, { message: 'Photo id must be specified when updating.' }], [!dataList.length, { message: 'No dataList or references specified.' }], [!!invalidReference, { message: 'Invalid reference ' + invalidReference + ' specified.' }]];

        // fail and return if there are errors
        if (failIfAny(possibleErrors)) {
            return;
        }

        // Make request and handle response
        onStart({ id: id, dataList: dataList });
        return resizePhoto(id, { dataList: dataList }).then(function (response) {
            ok({ photos: response.result });
        }).catch(fail);
    });
};

function cropPhoto(id, data) {
    var url = addTokenToUrl(endpoints.processPhoto(id));

    return fetchWrapper(url, addHeaders({
        method: 'post',
        body: JSON.stringify(data)
    }));
}

/**
 * Sends a request to the media service to cut sizes (specified in references) of the selected photo
 * @param   {String}  [params.id]            - the photoId of the photo to be cropped
 * @param   {Array}   [params.dataList]      - an array of transforms to be applied to the photo
 *
 * @param   {Function} [onStart]    - function(args) {} Called when resize begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when resize has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if resize fails
 * @returns {Promise}
 */
exports.cropPhoto = function (_ref11) {
    var payload = _ref11.payload,
        _ref11$onStart = _ref11.onStart,
        onStart = _ref11$onStart === undefined ? function () {} : _ref11$onStart,
        _ref11$onSuccess = _ref11.onSuccess,
        onSuccess = _ref11$onSuccess === undefined ? function () {} : _ref11$onSuccess,
        _ref11$onFail = _ref11.onFail,
        onFail = _ref11$onFail === undefined ? function () {} : _ref11$onFail;
    var id = payload.id,
        _payload$dataList = payload.dataList,
        dataList = _payload$dataList === undefined ? [] : _payload$dataList;


    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe4 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe4.ok,
            fail = _conditionalPromiseHe4.fail,
            failIfAny = _conditionalPromiseHe4.failIfAny;

        // Get Possible Errors


        var possibleErrors = [[!id, { message: 'Photo id must be specified when cropping.' }], [!dataList.length, { message: 'No dataList specified.' }]];

        if (failIfAny(possibleErrors)) {
            return;
        }

        onStart({ id: id, dataList: dataList });
        return cropPhoto(id, { dataList: dataList }).then(function (response) {
            ok({ photos: response.result });
        }).catch(fail);
    });
};

function getPhoto(id, fields) {
    var fieldsQueryString = fields ? '&fields=' + fields.join(',') : '';
    var url = addTokenToUrl(endpoints.getPhoto(id)) + fieldsQueryString;

    return fetchWrapper(url, addHeaders({
        method: 'get'
    }));
}

/**
 * Sends a request to the media service to cut sizes (specified in references) of the selected photo
 * @param   {String}  [params.id]            - the photoId of the photo to be cropped
 * @param   {Array}   [params.fields]      - an array of transforms to be applied to the photo
 *
 * @param   {Function} [onStart]    - function(args) {} Called when resize begins
 * @param   {Function} [onSuccess]  - function(data) {} Called when resize has completed successfully
 * @param   {Function} [onFail]     - function(err) {} Called if resize fails
 * @returns {Promise}
 */
exports.getPhoto = function (_ref12) {
    var payload = _ref12.payload,
        _ref12$onStart = _ref12.onStart,
        onStart = _ref12$onStart === undefined ? function () {} : _ref12$onStart,
        _ref12$onSuccess = _ref12.onSuccess,
        onSuccess = _ref12$onSuccess === undefined ? function () {} : _ref12$onSuccess,
        _ref12$onFail = _ref12.onFail,
        onFail = _ref12$onFail === undefined ? function () {} : _ref12$onFail;
    var id = payload.id,
        fields = payload.fields;


    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe5 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe5.ok,
            fail = _conditionalPromiseHe5.fail,
            failIfAny = _conditionalPromiseHe5.failIfAny;

        // Get Possible Errors


        var possibleErrors = [[!id, { message: 'Photo id must be specified when getting photo object.' }], [fields && !Array.isArray(fields), { message: 'Fields must be an array when requesting a photo.' }]];

        if (failIfAny(possibleErrors)) {
            return;
        }

        onStart({ id: id, fields: fields });
        return getPhoto(id, fields).then(function (response) {
            ok({ photo: response.result });
        }).catch(fail);
    });
};

/**
 * Ensures that the provided photo is within the dimensions given. Creates an Image object and checks its
 * naturalWidth and naturalHeight properties to do the comparison.
 * @param   {Object}   payload
 * @param   {File}     payload.file - the file to check
 * @param   {Object}   payload.errorMessages - Optional, used to override default error messages
 * @param   {Number}   payload.minHeight - Minimum height of the file, or 0 if none
 * @param   {Number}   payload.minWidth - Minimum width of the file, or 0 if none
 * @param   {Number}   payload.maxHeight - Maximum height, or 0 if none
 * @param   {Number}   payload.maxWidth - Maximum width, or 0 if none
 * @param   {Number}   payload.aspectRatio
 * @param   {Number}   payload.maxAspectRatioDiff - Optional, will default to 0.05
 * @param   {Object}   payload.resolver - Optional, should contain 2 functions {create, dispose}
 * @param   {Function} resolver.create - Creates an Image from the file passed in - mainly valuable for unit testing
 * @param   {Function} resolver.dispose - Performs any cleanup needed by resolver.create
 * @param   {Function} onSuccess - called if the image passes validation
 * @param   {Function} onFail - called if the image fails validation
 * @returns {Promise}
 */
exports.ensureValidPhotoDimensions = function (_ref13) {
    var payload = _ref13.payload,
        onSuccess = _ref13.onSuccess,
        onFail = _ref13.onFail;
    var file = payload.file,
        _payload$errorMessage5 = payload.errorMessages,
        errorMessages = _payload$errorMessage5 === undefined ? {} : _payload$errorMessage5,
        _payload$minHeight = payload.minHeight,
        minHeight = _payload$minHeight === undefined ? 1 : _payload$minHeight,
        _payload$maxHeight = payload.maxHeight,
        maxHeight = _payload$maxHeight === undefined ? 99999 : _payload$maxHeight,
        _payload$minWidth = payload.minWidth,
        minWidth = _payload$minWidth === undefined ? 1 : _payload$minWidth,
        _payload$maxWidth = payload.maxWidth,
        maxWidth = _payload$maxWidth === undefined ? 99999 : _payload$maxWidth,
        _payload$aspectRatio = payload.aspectRatio,
        aspectRatio = _payload$aspectRatio === undefined ? null : _payload$aspectRatio,
        resolver = payload.resolver;

    var between = function between(value, min, max) {
        return value <= max && value >= min;
    };
    var MAX_ASPECT_RATIO_DIFF = payload.maxAspectRatioDiff || 0.05;
    var isAspectRatioEqual = function isAspectRatioEqual(width, height) {
        return !aspectRatio || Math.abs(width / height - aspectRatio) < MAX_ASPECT_RATIO_DIFF;
    };

    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe6 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe6.ok,
            fail = _conditionalPromiseHe6.fail,
            failIf = _conditionalPromiseHe6.failIf;

        var _ref14 = resolver || createImageFromFile(),
            create = _ref14.create,
            dispose = _ref14.dispose;

        if (failIf(!(file && (file.id || file.name)), {
            message: errorMessages.fileNotSpecified || 'File was not specified.',
            args: payload
        })) {
            return;
        }

        create(file).then(function (img) {
            var width = img.naturalWidth;
            var height = img.naturalHeight;

            dispose(img);

            var hasMinimum = !!(payload.minHeight && payload.minWidth);
            var hasMaximum = !!(payload.maxHeight && payload.maxWidth);
            var noRange = payload.maxHeight === payload.minHeight && payload.maxWidth === payload.minWidth;
            var hasRatio = !!aspectRatio;

            var messages = [[hasRatio, 'an aspect ratio of ' + aspectRatio + ' width to height'], [noRange, maxWidth + ' x ' + maxHeight + ' pixels'], [hasMinimum && hasMaximum, 'between ' + minWidth + ' x ' + minHeight + ' and ' + maxWidth + ' x ' + maxHeight + ' pixels'], [hasMinimum, 'at least ' + minWidth + ' x ' + minHeight + ' pixels'], [hasMaximum, 'less than ' + maxWidth + ' x ' + maxHeight + ' pixels']];
            var invalidDimensionMessage = messages.reduce(function (prev, curr) {
                return prev || curr[0] && curr[1];
            }, null);

            if (between(width, minWidth, maxWidth) && between(height, minHeight, maxHeight) && isAspectRatioEqual(width, height)) {
                ok({ img: img, message: 'OK' });
            } else {
                var messagePrefix = errorMessages.invalidDimensions || 'The size of the image file must be';

                fail(Object.assign({}, payload, {
                    message: errorMessages.custom || messagePrefix + ' ' + invalidDimensionMessage + '.',
                    img: img,
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight,
                    aspectRatio: aspectRatio
                }));
            }
        }).catch(function (err) {
            var resource = err && err.srcElement && err.srcElement.src || 'Unknown';
            fail(Object.assign({}, payload, {
                message: 'Failed to load resource: ' + resource
            }));
        });
    });
};